"use strict";

var _slicedToArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tnodeSnapshot;
function printTableStyles(styles) {
  var entries = Object.entries(styles);
  return entries.reduce(function (prev, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      val = _ref2[1];
    return "".concat(prev).concat(prev ? ',' : '', " ").concat(name, ": ").concat(JSON.stringify(val));
  }, '');
}
function tnodePropertiesString(tnode, _ref3) {
  var withNodeIndex = _ref3.withNodeIndex,
    withStyles = _ref3.withStyles;
  var _tnode$classes;
  var tagPrint = tnode.tagName ? "tagName=\"".concat(tnode.tagName, "\"") : 'anonymous';
  var unregisteredPrint = tnode.isUnregistered ? 'unregistered' : null;
  var indexPrint = withNodeIndex ? "nodeIndex={".concat(tnode.nodeIndex, "}") : null;
  var idPrint = tnode.id ? "id=".concat(tnode.id) : null;
  var classesPrint = (_tnode$classes = tnode.classes) !== null && _tnode$classes !== void 0 && _tnode$classes.length ? "classes={[".concat(tnode.classes.join(', '), "]}") : null;
  var dataPrint = tnode.type === 'text' ? "data=".concat(JSON.stringify(tnode.data)) : null;
  var anchorPrint = typeof tnode.attributes.href === 'string' ? "href=".concat(JSON.stringify(tnode.attributes.href)) : null;
  var srcPrint = typeof tnode.attributes.src === 'string' ? "src=".concat(JSON.stringify(tnode.attributes.src)) : null;
  var pstyles = withStyles ? printTableStyles(tnode.getNativeStyles()) : null;
  var nativeStylesPrint = pstyles ? "nativeStyles={{".concat(pstyles, " }}") : null;
  var oStyles = withStyles ? printTableStyles(tnode.getWebStyles()) : null;
  var webStylesPrint = oStyles ? "webStyles={{".concat(oStyles, "}}") : null;
  var detailsPrint = [tagPrint, unregisteredPrint, indexPrint, idPrint, classesPrint, dataPrint, anchorPrint, srcPrint, nativeStylesPrint, webStylesPrint].filter(function (p) {
    return p !== null;
  }).join(' ');
  return "<".concat(tnode.displayName, " ").concat(detailsPrint);
}
function tnodeSnapshot(tnode, params) {
  var _params$parentLeftPre = params.parentLeftPrefix,
    parentLeftPrefix = _params$parentLeftPre === void 0 ? '' : _params$parentLeftPre,
    _params$isChild = params.isChild,
    isChild = _params$isChild === void 0 ? false : _params$isChild,
    _params$isLast = params.isLast,
    isLast = _params$isLast === void 0 ? true : _params$isLast,
    withStyles = params.withStyles,
    withNodeIndex = params.withNodeIndex;
  var prefix = isChild ? '  ' : '';
  var totalPrefixLeft = parentLeftPrefix + prefix;
  var childrenPrint = tnode.children.map(function (c, i) {
    return tnodeSnapshot(c, {
      parentLeftPrefix: parentLeftPrefix + ''.padStart(prefix.length, ' '),
      isChild: true,
      isLast: i === tnode.children.length - 1,
      withStyles: withStyles,
      withNodeIndex: withNodeIndex
    });
  }).join('');
  return "".concat(totalPrefixLeft).concat(tnodePropertiesString(tnode, {
    withStyles: withStyles,
    withNodeIndex: withNodeIndex
  })).concat(childrenPrint ? ">\n".concat(childrenPrint, "\n").concat(totalPrefixLeft, "</").concat(tnode.displayName, ">") : ' />').concat(isLast ? '' : '\n');
}